import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import LinkComponent from '../../utils/linkComponent';
import { StaticImage } from 'gatsby-plugin-image';

const FooterLinksStyled = styled.div`
	/* Gradient background from #2e4d8a to #af252d */
	background: linear-gradient(to right, #2e4d8a, #af252d);
	a {
		color: var(--secondary_2);
		text-decoration: none;
	}
	.thetaLogo {
		max-width: 15em;
		max-height: 100px;
		object-fit: contain;
	}
	.footerRow {
		padding: 0em 0em;
		margin: -0.5em 0em 0em 0em;
	}
	.thetaLogoCol {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		padding-left: 7px;
		padding-top: 0.5em;
	}
	.sponsorsLogosCol {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	}
	.social_media_icons {
		font-size: 3rem;
	}
	.linkedinSocials {
		color: white;
	}

	/* Target Bootstrap Container directly */
	.container {
		padding-top: 0.5em !important;
		padding-bottom: 0.5em !important;
	}

	@media (max-width: 1199.5px) {
		.sponsorsLogosCol {
			padding-right: 0;
		}
	}

	@media (max-width: 768px) {
		.thetaLogoCol {
			width: 62%;
		}
		.sponsorsLogosCol {
			justify-content: center;
			flex-wrap: wrap;
		}
		.sponsorsLogosCol > .row {
			width: 100%;
			margin: 0;
			justify-content: center;
			align-items: center;
		}
		.sponsorsLogosCol .col {
			padding: 0;
			margin: 0.5rem;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
`;

export default function FooterLinks() {
	return (
		<FooterLinksStyled>
			<Container>
				<Row className='footerRow'>
					<Col sm={6} className='thetaLogoCol'>
						<Row>
							<Col>
								<LinkComponent to={`/`}>
									<StaticImage
										src='../../images/Stronger-together-logo.png'
										className='thetaLogo'
										alt='Footer Logo'
										loading='lazy'
									/>
								</LinkComponent>
							</Col>
						</Row>
					</Col>
					<Col className='sponsorsLogosCol'>
						<Row>
							<Col>
								<div className='social_media_icons'>
									<a
										target='_blank'
										rel='noopener noreferrer'
										href='https://www.linkedin.com/company/3253172'
										aria-label='LinkedIn Page'
										className='linkedinSocials'
									>
										<FontAwesomeIcon icon={faLinkedin} />
									</a>
								</div>
							</Col>
							<Col className='mx-3' style={{ alignSelf: 'center' }}>
								<Link
									style={{
										textWrap: 'nowrap',
										textDecoration: 'underline',
										color: 'white',
									}}
									to='/contact-us'
								>
									Contact Us
								</Link>
							</Col>
						</Row>
					</Col>
				</Row>
			</Container>
		</FooterLinksStyled>
	);
}
